import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";
import cookiesService from "./services/CookiesServices";
import reportWebVitals from "./reportWebVitals";

import * as serviceWorkerRegistration from "../src/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
const allowedApisWithoutToken = [
  "/adminusers/verify",
  // Add more public endpoints as needed
];
axios.interceptors.request.use(
  async function (config) {
    // Removed console.logs for production performance

    const url = config.url || "";
    const isAllowedApi = allowedApisWithoutToken.some((api) =>
      url.includes(api)
    );
    // Never send "Bearer undefined" — many backends reject it; missing header is clearer than invalid JWT.
    if (!isAllowedApi) {
      try {
        let token = await cookiesService.get("token");
        if (token) {
          if (!config.headers) config.headers = {};
          config.headers["Authorization"] = "Bearer " + token;
        }
      } catch (error) {
        // Only log errors in development
        if (process.env.NODE_ENV === 'development') {
        console.error("Error getting token:", error);
        }
        return Promise.reject(error);
      }
    }

    return config;
  },
  function (error) {
    // Only log errors in development
    if (process.env.NODE_ENV === 'development') {
    console.error("Request interceptor error:", error);
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Do something with successful response
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

// Only use StrictMode in development for better performance in production
if (process.env.NODE_ENV === 'development') {
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
} else {
  root.render(<App />);
}

// Register service worker asynchronously to not block initial render
// This ensures the UI loads immediately and service worker registers in background
if (typeof window !== 'undefined') {
  // Use requestIdleCallback for non-blocking registration
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      serviceWorkerRegistration.register();
    }, { timeout: 2000 });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      serviceWorkerRegistration.register();
    }, 0);
  }
}
// Only run web-vitals in development to avoid loading the library in production
if (process.env.NODE_ENV === "development" && typeof reportWebVitals === "function") {
  reportWebVitals();
}
